export default __webpack_public_path__ + "static/media/logo.3fa2f578.svg";